import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-expense-attachment-modal',
  templateUrl: './view-expense-attachment-modal.component.html',
  styleUrls: ['./view-expense-attachment-modal.component.css']
})
export class ViewExpenseAttachmentModalComponent implements OnInit {
  @Input() receiptDetails: any;
  @Input() receiptItemsDetails: any;
  @Input() receiptAttachments: any;
  alert: any;
  selectedAttachment: any;

  constructor(private ngbActiveModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.selectedAttachment = this.receiptAttachments[0];
  }

  close() {
    this.ngbActiveModal.close();
  }
}
